<template>
  <div class="sc-filter">
    <div class="sc-filter-list">
      <span v-if="label" class="f-ui-2">{{ label }}</span>
      <div class="filter-items">
        <button
          v-for="option in options.toSorted()"
          :key="option"
          class="a-button a-button--anchor"
          :class="{ 's-active': selectedOption === option }"
          @click="() => click(option)"
        >
          {{ option }}
        </button>
      </div>
    </div>
    <Dropdown
      :label="label"
      :value="selectedOption"
      :options="options.toSorted()"
      @input="(d) => click(d)"
      class="sc-filter-dropdown"
    />
  </div>
</template>

<script>
import { Dropdown } from "@international-energy-agency/vue-ui";
export default {
  name: "ScorecardFilters",
  components: {
    Dropdown,
  },
  data() {
    return {};
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    selectedOption: {
      type: String,
      required: false,
    },
  },
  watch: {
    options(newOptions, oldOptions) {
      if (!newOptions.includes(this.selectedOption)) {
        this.$emit("changed", newOptions[0]);
      }
    },
  },
  methods: {
    click(value) {
      this.$emit("changed", value);
    },
  },
};
</script>

<style>
.sc-filter {
  /*margin-left: calc(322px + 32px);*/
  flex: 2;
  margin-left: 24px;
  margin-bottom: 48px;
}
.sc-filter-list {
  padding-top: 12px;
}
.filter-items > * {
  margin: 4px;
  font-size: 0.875rem;
}
.filter-label {
  padding: 4px 0;
  min-width: 100px;
  font-weight: 600;
}
.sc-filter-dropdown {
  display: none;
  visibility: hidden;
}

@media screen and (max-width: 959px) {
  .sc-filter {
    margin-left: 0;
  }
  .sc-filter-dropdown {
    display: block;
    visibility: visible;
  }
  .sc-filter-list {
    display: none;
    visibility: hidden;
  }
}
</style>
